import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-aggrid',
	templateUrl:'./AgGridPluginPage.html',
	styles: [],
	styleUrls:['./AgGridPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgGridPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_512 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>aggrid</artifactId>
</dependency>
\`\`\``;
	mdContent_513 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:aggrid:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_514 = `\`\`\`json
"ag-grid-angular": "^35.0.0"
"ag-grid-community": "^35.0.0"
\`\`\``;
	mdContent_515 = `\`\`\`java
public class OrderGrid extends AgGrid<OrderGrid> {
    public OrderGrid() {
        setHeight("600px")
            .enablePagination(25)
            .enableRowSelection("multiple");

        addColumn(new AgGridColumnDef()
            .setField("orderId")
            .setHeaderName("Order ID")
            .setWidth(100));

        addColumn(new AgGridColumnDef()
            .setField("total")
            .setHeaderName("Total")
            .setCellDataType("number"));
    }
}
\`\`\``;
	mdContent_516 = `\`\`\`java
AgGridOptions<?> options = new AgGridOptions<>();
options.configureRendering()
    .setAnimateRows(true)
    .setCellFlashDuration(500);
options.configurePagination()
    .setPagination(true)
    .setPaginationPageSize(50);
\`\`\``;
	mdContent_517 = `\`\`\`java
public class OrderGrid extends AgGrid<OrderGrid> {
    public OrderGrid() {
        setHeight("600px")
            .enablePagination(25)
            .enableRowSelection("multiple");

        addColumn(new AgGridColumnDef()
            .setField("orderId")
            .setHeaderName("Order ID")
            .setWidth(100));

        addColumn(new AgGridColumnDef()
            .setField("status")
            .setHeaderName("Status")
            .setCellRenderer(StatusBadgeRenderer.class));
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
